import { AuditContext, AuditDecision, AuditRule } from './types';

export const AUDIT_RULES: AuditRule[] = [
  {
    id: 'custom_built_index',
    requiresMeta: true,
    matches(ctx) {
      return ctx.functionName === 'custom_built_index';
    },
    evaluate(ctx) {
      return {
        auditable: true,
        handler: 'default',
        auditFunctionName: 'custom_built_index',
        payload: ctx.params ?? {},
      };
    },
  },
  {
    id: 'company_data',
    requiresMeta: true,
    matches(ctx) {
      return ctx.functionName === 'company_data';
    },
    evaluate(ctx) {
      const p = ctx.params ?? {};
      const datatype =
        typeof p.dataType === 'string' ? p.dataType : undefined;

      if (
        datatype?.toLowerCase() !== 'ipo_offering_price' &&
        datatype?.toLowerCase() !== 'date_first_trading'
      ) {
        return {
          auditable: false,
          reason:
            "company_data is auditable only when datatype is 'ipo_offering_price' or 'date_first_trading'",
        };
      }

      return {
        auditable: true,
        handler: 'company-data-prospectus',
        auditFunctionName: 'company_data',
        payload: p,
      };
    },
  },
  {
    id: 'market_derived_data',
    requiresMeta: true,
    matches(ctx) {
      return ctx.functionName === 'market_derived_data';
    },
    evaluate(ctx) {
      return {
        auditable: true,
        handler: 'default',
        auditFunctionName: 'market_derived_data',
        payload: ctx.params ?? {},
      };
    },
  },
];

export function resolveAuditDecision(ctx: AuditContext): AuditDecision {
  const matchingRules = AUDIT_RULES.filter((rule) => rule.matches(ctx));

  if (!matchingRules.length) {
    return {
      auditable: false,
      reason: `No audit rule registered for function "${ctx.rawFunctionName ?? ctx.functionName}"`,
    };
  }

  for (const rule of matchingRules) {
    if (rule.requiresMeta && !ctx.meta) continue;

    const decision = rule.evaluate(ctx);
    if (decision.auditable) return decision;
  }

  for (const rule of matchingRules) {
    if (rule.requiresMeta && !ctx.meta) {
      return {
        auditable: false,
        reason: `Audit rule "${rule.id}" requires FunctionCallCache meta, but meta is missing`,
      };
    }

    const decision = rule.evaluate(ctx);
    if (!decision.auditable) return decision;
  }

  return {
    auditable: false,
    reason: `No eligible audit rule matched function "${ctx.rawFunctionName ?? ctx.functionName}"`,
  };
}
